import { makeStyles } from "@material-ui/styles";

const driveSummaryStyles = makeStyles(() => ({
	column: {
		"&.x-small": {
			width: 40,
			paddingLeft: 10,
			paddingRight: 10
		},
		"&.small": {
			width: 80
		},
		"&.medium": {
			width: 150
		}
	},
	row: {
		"& > *": {
			borderBottom: "unset"
		}
	},
	cell: {
		paddingBottom: 0,
		paddingTop: 0
	}
}));

export default driveSummaryStyles;
